<template>
  <v-card outlined width="100%">
    <div align="center">
      <div v-if="!chartData.length" style="display: grid" class="py-3 subtitle-1 justify-center align-center">
        <span class="title"> {{ title }} </span>
        <span class="my-16 subtitle-2 font-weight-medium">  {{ $t('noData')}} </span>
      </div>
      <ejs-chart v-else
        ref="barChart"
        :theme="theme"
        align="center"
        :title="title"
        :primaryXAxis="primaryXAxis"
        :primaryYAxis="primaryYAxis"
        :chartArea="chartArea"
        :tooltip="tooltip"
        :load="load"
        height="70%"
        width="100%"
      >
        <e-series-collection>
          <e-series
            :dataSource="filterChartData[0]"
            type="Column"
            xName="x"
            yName="y"
            :name="$t('statistics.lblSumOfScheduleTime')"
            width="2"
            :marker="marker"
             tooltipMappingName='text'
          >
          </e-series>
          <e-series
            :dataSource="filterChartData[1]"
            type="Column"
            xName="x"
            yName="y"
            :name="$t('statistics.lblSumOfActualTime')"
            width="2"
            :marker="marker"
             tooltipMappingName='text'
          >
          </e-series>
        </e-series-collection>
      </ejs-chart>
    </div>
  </v-card>
</template>
<style scoped>
.title {
  font-size: 15px !important;
}
</style>
<script>
import Vue from "vue";
import { Browser } from "@syncfusion/ej2-base";
import {
  ChartPlugin,
  ColumnSeries,
  Category,
  DataLabel,
  Tooltip,
  Legend,
} from "@syncfusion/ej2-vue-charts";
import {toHoursAndMinutes } from "@/utils/util";
Vue.use(ChartPlugin);

let selectedTheme = location.hash.split("/")[1];
selectedTheme = selectedTheme ? selectedTheme : "Material";
let theme = (
  selectedTheme.charAt(0).toUpperCase() + selectedTheme.slice(1)
).replace(/-dark/i, "Dark");

export default Vue.extend({
  name: "ActualTimeByAgendaCategoryChart",
  props: {
    chartData: {
      type: Array,
      default: () => [],
    },
    props: {
      type: String,
      default: "agendaCategory",
    },
    title: String,
  },
  data: function () {
    return {
      theme: theme,
      //Initializing Primary X Axis
      primaryXAxis: {
        valueType: "Category",
        interval: 1,
        majorGridLines: { width: 0 },
      },
      chartArea: { border: { width: 0 } },

      //Initializing Primary Y Axis
      primaryYAxis: {
        // majorGridLines: { width: 0 },
        // majorTickLines: { width: 0 },
        // lineStyle: { width: 0 },
        // labelStyle: { color: "transparent" },

        edgeLabelPlacement: "Shift",
        // minimum: 0,
        // maximum: 30,
        // interval: 5,
        labelFormat: "{value} min",
        majorTickLines: { width: 0 },
        minorTickLines: { width: 0 },
      },

      width: Browser.isDevice ? "100%" : "60%",
      marker: { dataLabel: {  position: "Top",visible: true, name: 'text',font: { fontWeight: "600", color: "#ffffff" }} },
      // marker: {
      //   dataLabel: {
      //     visible: true,
      //     position: "Top",
      //     font: { fontWeight: "600", color: "#ffffff" },
      //   },
      // },

      // tooltip: {
      //   enable: true,
      //   header: "",
      //   format: '${point.x} : <b>${point.y}</b>'
      // },

           tooltip: {enable: true,  header: "",format: '${point.x} : <b>${point.tooltip}</b>'},

      // title: "Total Scheduled Time Vs Actual Time By Agenda Category",
    };
  },
  created() {
    //this.$refs.barChart.ej2Instances.refresh();
  },
  mounted() {
    this.$refs.barChart?.ej2Instances.refresh();
  },
  computed: {
    filterChartData() {
      const data = groupByTime(this.chartData, this.props);
      const seriesData = [];
      const seriesData1 = [];
      data.forEach((value) => {
        const first = {
          x: value[this.props],
          y: value.scheduleTime,   
          text: this.toHoursAndMinutes(value.scheduleTime),  
        };
        const second = {
          x: value[this.props],
          y: value.actualTime, 
            text: this.toHoursAndMinutes(value.actualTime),           
        };
        seriesData.push(first);
        seriesData1.push(second);
      });

      return [seriesData, seriesData1];
    },
  },
  provide: {
    chart: [ColumnSeries, Legend, DataLabel, Category, Tooltip],
  },
  methods: {
    load: function (args) {
      let selectedTheme = location.hash.split("/")[1];
      selectedTheme = selectedTheme ? selectedTheme : "Material";
      if (selectedTheme === "highcontrast") {
        args.chart.series[0].marker.dataLabel.font.color = "#000000";
        args.chart.series[1].marker.dataLabel.font.color = "#000000";
        args.chart.series[2].marker.dataLabel.font.color = "#000000";
      }
    },
    toHoursAndMinutes,
  },
});

const groupByTime = (arr = [], props) => {
  const map = {};
  let res = [];
  res = arr.reduce((acc, val) => {
    const { scheduleTime, actualTime } = val;
    const propsData = val[props];
    const { length: l } = acc;
    if (map.hasOwnProperty(propsData)) {
      acc[map[propsData]]["scheduleTime"] =
        acc[map[propsData]]["scheduleTime"] + Number(scheduleTime);
      acc[map[propsData]]["actualTime"] =
        acc[map[propsData]]["actualTime"] + Number(actualTime);
    } else {
      map[propsData] = l;
      acc.push({
        [props]: propsData,
        scheduleTime: Number(scheduleTime),
        actualTime: Number(actualTime),
      });
    }
    return acc;
  }, []);
  return res;
};
</script>